import { render, staticRenderFns } from "./QuestionTag.vue?vue&type=template&id=e1a2b378&"
import script from "./QuestionTag.vue?vue&type=script&lang=js&"
export * from "./QuestionTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports